import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TopBannerAd = () => {
  const location = useLocation();

  useEffect(() => {
    const container = document.getElementById("top-banner-ad");

    if (!container) return;

    container.innerHTML = "";

    const isMobile = window.innerWidth < 768;

    const atScript = document.createElement("script");

    // 📱 Mobile Ad (320x50)
    if (isMobile) {
      atScript.innerHTML = `
        atOptions = {
          'key' : '3742393f660d0d7ec16b3504b828721a',
          'format' : 'iframe',
          'height' : 50,
          'width' : 320
        };
      `;

      const script = document.createElement("script");
      script.src =
        "https://www.highperformanceformat.com/3742393f660d0d7ec16b3504b828721a/invoke.js";
      script.async = true;

      container.appendChild(atScript);
      container.appendChild(script);
    }

    // 🖥️ Desktop Ad (728x90 BIG BANNER)
    else {
      atScript.innerHTML = `
        atOptions = {
          'key' : 'a3fef7ba0a8264d69fe9ce39ea522fcd',
          'format' : 'iframe',
          'height' : 90,
          'width' : 728
        };
      `;

      const script = document.createElement("script");
      script.src =
        "https://www.highperformanceformat.com/a3fef7ba0a8264d69fe9ce39ea522fcd/invoke.js";
      script.async = true;

      container.appendChild(atScript);
      container.appendChild(script);
    }
  }, [location.pathname]);

  return (
    <div
      id="top-banner-ad"
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        margin: "10px 0",
        overflow: "hidden",
      }}
    ></div>
  );
};

export default TopBannerAd;